import React from "react";
import { SCHOOL_URL, COMPANY_URL } from "../../constants/urls";

const Login: React.FC = () => (
  <div>
    <h2>로그인</h2>
    <ul>
      <li>
        <a href={SCHOOL_URL}>학교용 보건일지</a>
      </li>
      <li>
        <a href={COMPANY_URL}>기업용 보건일지</a>
      </li>
    </ul>
  </div>
);

export default Login;
